import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutBrandNodes = function useLoggedOutBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutBrandNodes = {
    L1: {
      Account: strictLocalize({
        id: "7flPEZ",
        defaultMessage: [{
          "type": 0,
          "value": "Accountinstellingen (bijv. update e-mail, bankgegevens)"
        }]
      }),
      Catalog: strictLocalize({
        id: "PewJ+O",
        defaultMessage: [{
          "type": 0,
          "value": "Informatie over catalogus en winkel"
        }]
      }),
      Disputes: strictLocalize({
        id: "Sb6ix0",
        defaultMessage: [{
          "type": 0,
          "value": "Geschillen"
        }]
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: [{
          "type": 0,
          "value": "Facturen en betalingen"
        }]
      }),
      Orders: strictLocalize({
        id: "lour39",
        defaultMessage: [{
          "type": 0,
          "value": "Bestellingen en fulfillment"
        }]
      }),
      UpdateCommission: strictLocalize({
        id: "9/FL8z",
        defaultMessage: [{
          "type": 0,
          "value": "Update commissie/relatie"
        }]
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: [{
          "type": 0,
          "value": "Algemene verzendingsvragen"
        }]
      }),
      Other: strictLocalize({
        id: "anUKfs",
        defaultMessage: [{
          "type": 0,
          "value": "Andere merkproblemen"
        }]
      })
    },
    L2: {
      SWF: strictLocalize({
        id: "xc/zXa",
        defaultMessage: [{
          "type": 0,
          "value": "Verzenden met Faire"
        }]
      }),
      SOYO: strictLocalize({
        id: "R22FJg",
        defaultMessage: [{
          "type": 0,
          "value": "Met eigen vervoerder verzenden"
        }]
      }),
      SellingInternational: strictLocalize({
        id: "vNJE8v",
        defaultMessage: [{
          "type": 0,
          "value": "Internationaal verkopen"
        }]
      }),
      Other: strictLocalize({
        id: "+c3AoM",
        defaultMessage: [{
          "type": 0,
          "value": "Overige vragen"
        }]
      })
    },
    L3: {
      Availability: strictLocalize({
        id: "UaBkUO",
        defaultMessage: [{
          "type": 0,
          "value": "Is Verzenden met Faire beschikbaar in mijn land?"
        }]
      }),
      LabelIssues: strictLocalize({
        id: "1HdGkw",
        defaultMessage: [{
          "type": 0,
          "value": "Etiketteringsproblemen"
        }]
      }),
      Costs: strictLocalize({
        id: "oQXdAP",
        defaultMessage: [{
          "type": 0,
          "value": "Kosten"
        }]
      }),
      Others: strictLocalize({
        id: "IwX/dA",
        defaultMessage: [{
          "type": 0,
          "value": "Andere"
        }]
      }),
      HowTo: strictLocalize({
        id: "ayEfYp",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe werkt het?"
        }]
      })
    }
  };
  return loggedOutBrandNodes;
};